const implementsFunction = (x, fn) => typeof x?.[fn] === "function";
export {
  implementsFunction
};
